import React from 'react';
import './Docs.css';

function Docs({ language = 'en', onLanguageChange }) {
  // 文本内容配置
  const messages = {
    en: {
      docsTitle: "Arky Context Dictionary Manual",
      englishGuide: "User Guide",
      step1Title: "Enter English Text",
      step1Content: "In the search box on the homepage, enter one or more complete English sentences. Make sure your spelling and grammar are correct to get accurate contextual analysis.",
      step2Title: "Select the Target Word",
      step2Content: "The system will segment your input into words. Hover over any word to highlight it, then click on the word you want to analyze.",
      step3Title: "View Contextual Analysis",
      step3Content: "Click the \"Analyze\" button. The system will combine the current sentence context to provide the most appropriate English definition and usage guidance.",
      step4Title: "Immersive Learning Experience",
      step4Content: "Except for this user guide, all website content is in English. This creates an immersive language learning environment to help you master word usage in real contexts.",
      tipsTitle: "Usage Tips",
      tip1: "Ensure that your input contains no spelling mistakes",
      tip2: "Enter complete sentences containing the target word instead of isolated words",
      tip3: "Providing full context helps the system generate more accurate analysis",
    },
    zh: {
      docsTitle: "舟义语境词典使用手册",
      chineseGuide: "使用说明",
      step1Title: "输入英文文本",
      step1Content: "在首页的搜索框中输入一个或多个完整的英文句子。请确保拼写和语法正确，以获得准确的语境分析结果。",
      step2Title: "选择目标单词",
      step2Content: "系统会将您输入的文本进行分词。将鼠标移动到任意单词上，背景会高亮显示，点击即可选择需要分析的单词。",
      step3Title: "查看语境分析",
      step3Content: "点击\"开始分析\"按钮，系统将结合当前句子语境，提供最合适的英文释义。",
      step4Title: "沉浸式学习体验",
      step4Content: "除本使用文档外，网站所有内容均为英文，旨在为您构建一个沉浸式的语言学习环境，帮助您在真实语境中掌握单词用法。",
      tipsTitle: "使用提示",
      tip1: "务必确保输入的文本无拼写错误",
      tip2: "请输入包含目标单词的完整句子，而非单独单词",
      tip3: "完整的语境能支持更精确的释义分析",
    }
  };

  const zh = messages.zh;
  const en = messages.en;
  const showChinese = language === 'zh';

  return (
    <div className="docs-container">
      {/* Header */}
      <div className="docs-header">
        <h1>{language === 'zh' ? zh.docsTitle : en.docsTitle}</h1>
        <div className="docs-header-controls">
          <button className="language-switch" onClick={onLanguageChange}>
            {language === 'en' ? '中文' : 'English'}
          </button>
        </div>
      </div>

      {/* Content */}
      <div className="docs-content">
        {/* 中文版本 - 只在中文界面显示 */}
        {showChinese && (
          <section className="language-section">
            <h2 className="language-title">{zh.chineseGuide}</h2>
            <div className="instructions-list">
              {[1, 2, 3, 4].map(i => (
                <div key={i} className="instruction-item">
                  <div className="step-number">{i}</div>
                  <div className="step-content">
                    <h3>{zh[`step${i}Title`]}</h3>
                    <p>{zh[`step${i}Content`]}</p>
                  </div>
                </div>
              ))}
            </div>
          </section>
        )}

        {/* 英文版本 - 始终显示 */}
        {language === 'en' && (
          <section className="language-section">
            <h2 className="language-title">{en.englishGuide}</h2>
            <div className="instructions-list">
              {[1, 2, 3, 4].map(i => (
                <div key={i} className="instruction-item">
                  <div className="step-number">{i}</div>
                  <div className="step-content">
                    <h3>{en[`step${i}Title`]}</h3>
                    <p>{en[`step${i}Content`]}</p>
                  </div>
                </div>
              ))}
            </div>
          </section>
        )}

        {/* 使用提示 */}
        <div className="tips-section">
          <h3>{language === 'zh' ? zh.tipsTitle : en.tipsTitle}</h3>
          
          {language === 'zh' ? (
            <ul className="tips-list">
              <li>{zh.tip1}</li>
              <li>{zh.tip2}</li>
              <li>{zh.tip3}</li>
            </ul>
          ) : (
            <ul className="tips-list english">
              <li>{en.tip1}</li>
              <li>{en.tip2}</li>
              <li>{en.tip3}</li>
            </ul>
          )}
        </div>
      </div>

      {/* Footer */}
        <footer className="docs-site-footer">
          <div className="docs-footer-content">
            <span>© 2026 Arky Context Dictionary. All rights reserved.</span>
            <span>Contact Us: contact@qiaohuisi.cn</span>
            <span>
              <a
                href="https://beian.miit.gov.cn/"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="beian-link"
              >
                粤ICP备2026001874号-1
              </a>
            </span>
            <span>
              <img src="/beian.png" alt="公安备案图标" className="beian-icon" />
              <a
                href="https://beian.mps.gov.cn/#/query/webSearch?code=44030002010758"
                target="_blank"
                rel="noreferrer"
                className="beian-link"
              >
                粤公网安备44030002010758号
              </a>
            </span>
          </div>
        </footer>
    </div>
  );
}

export default Docs;